import { lovemoBrand, lovemoSteps } from '@/mocks/lovemoContent';
import LovemoSectionHeading from '@/components/feature/LovemoSectionHeading';

const platformList = [
  { name: 'Android', icon: 'ri-android-line', tip: '适配主流安卓机型' },
  { name: 'iOS', icon: 'ri-apple-line', tip: '适配 iPhone / iPad' },
  { name: 'HarmonyOS', icon: 'ri-smartphone-line', tip: '适配华为鸿蒙设备' },
  { name: 'Windows', icon: 'ri-windows-line', tip: '适配 Win 10 / 11' },
];

export default function LovemoDownloadGuide() {
  return (
    <section id="lovemo-download" className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <LovemoSectionHeading
              align="left"
              eyebrow="下载教程"
              title="四步完成Lovemo安装"
              desc={
                <>
                  为了确保安装包安全可靠，建议通过官网获取<span className="whitespace-nowrap font-semibold text-primary-600">Lovemo官方正版免费下载</span>，整个流程只需要几分钟。
                </>
              }
            />

            <ol className="mt-10 space-y-6">
              {lovemoSteps.map((step) => (
                <li key={step.id} className="lovemo-reveal flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50 dark:text-background-950">
                    {step.index}
                  </span>
                  <div className="pt-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{step.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="lovemo-reveal">
            <div className="rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-7">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                  <i className="ri-device-line" aria-hidden="true" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">支持的全平台版本</h3>
              </div>

              <ul className="mt-5 space-y-3">
                {platformList.map((platform) => (
                  <li
                    key={platform.name}
                    className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-100 px-4 py-3"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-lg text-secondary-700">
                      <i className={platform.icon} aria-hidden="true" />
                    </span>
                    <span className="flex flex-col">
                      <span className="font-label text-sm font-bold text-foreground-950">{platform.name}</span>
                      <span className="text-xs text-foreground-600">{platform.tip}</span>
                    </span>
                    <i className="ri-checkbox-circle-fill ml-auto text-lg text-primary-500" aria-hidden="true" />
                  </li>
                ))}
              </ul>

              <div className="mt-5 rounded-xl bg-primary-50 px-4 py-3.5">
                <p className="flex items-start gap-2 text-xs leading-relaxed text-primary-800">
                  <i className="ri-lightbulb-line mt-0.5 text-base text-primary-600" aria-hidden="true" />
                  点击页面顶部或首屏的下载按钮，在弹窗中选择你的设备系统，即可获取对应版本的安装包。
                </p>
              </div>
            </div>

            <div className="relative isolate mt-6 overflow-hidden rounded-2xl border border-background-200/70 bg-gradient-to-br from-secondary-50 via-accent-50 to-primary-50 p-6">
              <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-accent-200/40 blur-2xl" />
              <div className="relative flex items-center gap-4">
                <img
                  src={lovemoBrand.mascotAlt}
                  alt="Lovemo吉祥物"
                  className="h-20 w-20 shrink-0 object-contain"
                  width={80}
                  height={80}
                />
                <div>
                  <p className="font-heading text-sm font-bold text-foreground-950">第一次使用？</p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-700">
                    创建专属伙伴后，试着说出今天的心情，Lovemo会陪你一起聊下去。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}